import { ProfessionAreaChartItem } from 'src/models/pages/profession';

import { CHART_MARGIN } from 'src/pages/Profession/components/SectionStatistics/AreaChart/Chart/constants';
import { getChartItemColor } from 'src/pages/Profession/components/SectionStatistics/AreaChart/Chart/helpers';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

const CustomTooltipPoint = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { activeTooltipIndex, activeCoordinate, isTooltipActive, tooltipTicks, activePayload } = props;
    if (!isTooltipActive || !activeCoordinate || activeTooltipIndex === -1 || !activePayload) {
        return null;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
    const tick = tooltipTicks[activeTooltipIndex];
    const size = 8;

    return (
        <svg
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            x={tick.coordinate - size / 2}
            y={CHART_MARGIN.top - size}
            width={size}
            height={size}
            viewBox={`0 0 ${size} ${size}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M-2.59251e-08 0.593137C-3.44953e-08 0.789215 0.0855345 0.946078 0.191195 1.15196L3.32579 7.45098C3.53711 7.86765 3.73333 8 4 8C4.26667 8 4.45786 7.86765 4.66918 7.45098L7.8088 1.15196C7.91447 0.941177 8 0.784314 8 0.588235C8 0.22549 7.71824 -1.2317e-08 7.2805 -3.14524e-08L0.719497 0.00490164C0.281761 0.00490162 -1.00701e-08 0.230392 -2.59251e-08 0.593137Z"
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                fill={getChartItemColor(activePayload[0].payload as ProfessionAreaChartItem)}
            />
        </svg>
    );
};

export default CustomTooltipPoint;
